import { graphql } from "react-relay";
import { defineMessage } from "react-intl";
import { Badge as BadgeName } from "./__generated__/badges.graphql";
import { MessageDescriptor } from "react-intl";
import test from "./test.png";
import paris2024_winners from "./paris2024-winners.webp";
import paris2024_hackers from "./paris2024-hackers.webp";
import chicago_2023 from "./chicago2023.png";
import trieste_2023 from "./trieste2023.png";
import paris_2023 from "./paris2023.png";
import grenoble_2022 from "./grenoble2022.jpg";
import montreal_2022 from "./montreal2022.jpg";
import bigparis_2021 from "./bigparis2021.jpg";
import paris_2021 from "./paris2021.jpg";
import quantum_pioneer from "./quantum-pioneer.png";
import ingenii2024first from "./ingenii2024-1st.svg";
import ingenii2024second from "./ingenii2024-2nd.svg";
import ingenii2024third from "./ingenii2024-3rd.svg";
import ingenii2024default from "./ingenii2024-default.svg";
import ingenii2024special from "./ingenii2024-special.svg";
import q2b2024gold from "./q2b-2024-Gold.png";
import q2b2024silver from "./q2b-2024-Silver.png";
import q2b2024bronze from "./q2b-2024-Bronze.png";
import q2b2024onsite from "./q2b-2024-On-site.png";
import q2b2024remote from "./q2b-2024-Remote.png";
import novacene2024 from "./novacene2024.svg";
import qinnovision2025winner from "./qinnovision-2025-winner.svg";
import qinnovision2025finalist from "./qinnovision-2025-finalist.svg";
import quantumsignalslob2025first from "./quantum-signals-lob-2025-first.svg";
import quantumsignalslob2025second from "./quantum-signals-lob-2025-second.svg";
import qmlsummerschool2025 from "./qml-summer-school-2025.png";
import epri_1st from "./epri-1st.png";
import epri_2nd from "./epri-2nd.png";
import epri_3rd from "./epri-3rd.png";
import gic2025wellsfargo from "./gic-2025-wells-fargo.svg";
import gic2025jpmc from "./gic-2025-jpmc.svg";
import gic2025worldbank from "./gic-2025-world-bank.svg";
import gic2025mitre from "./gic-2025-mitre.svg";
import gic2025neuroquantum from "./gic-2025-neuroquantum.svg";
import bradfordclinicaltrialoptimization from "./bradford-clinical-trial-optimization.png";
import bradfordbringyourownusecase from "./bradford-bring-your-own-usecase.png";
import bradfordcryptography from "./bradford-cryptography.png";
import bradfordquantumbrush from "./bradford-quantum-brush.png";
import pushquantumhaiqearlyfaulttolerantcircuits from "./pushquantum-haiq-early-fault-tolerant-circuits.png";
import pushquantumqoroquantummoleculardetective from "./pushquantum-qoro-quantum-molecular-detective.png";
import pushquantumquandelaquantumoptionpricing from "./pushquantum-quandela-quantum-option-pricing.png";
import qffcolorcode from "./qff-color-code.png";
import qffquantummachinelearning from "./qff-quantum-machine-learning.png";
import qffquantumrandomwalk from "./qff-quantum-random-walk.png";
import bqhqatarfinalist2025 from "./bqh-qatar-finalist-2025.png";
import bqhqatarwinner2025 from "./bqh-qatar-winner-2025.png";
import hthwinnerteam from "./hth-winner-team.png";
import hthparticipation from "./hth-participation.png";
import hthmostimpactfulteam from "./hth-most-impactful-team.png";
import hthmostinnovativeidea from "./hth-most-innovative-idea.png";
import QVOLUTION_26_ENERGY from "./QVOLUTION_26_ENERGY.png";
import QVOLUTION_26_LINEAR_DIFF from "./QVOLUTION_26_LINEAR_DIFF.png";
import QVOLUTION_26_QUANTUM_FOR_GOOD from "./QVOLUTION_26_QUANTUM_FOR_GOOD.png";
import QVOLUTION_26_FINANCE from "./QVOLUTION_26_FINANCE.png";
import gic2026mitsubishi from "./gic-2026-mitsubishi.png";
import gic2026qbraidmitrejones from "./gic-2026-qbraid-mitre-jones.png";
import gic2026quantumcomputinginc from "./gic-2026-quantum-computing-inc.png";
import gic2026usdoe from "./gic-2026-us-doe.png";

graphql`
  fragment badges on EntityBadge {
    badge
  }
`;

export interface Badge {
  id: BadgeName;
  name: MessageDescriptor;
  description: MessageDescriptor;
  image: string;
}

function createBadges(...badges: Badge[]): Record<BadgeName, Badge> {
  return badges.reduce<Record<BadgeName, Badge>>(
    (acc, badge) => {
      const duplicated = acc[badge.id];
      if (duplicated) {
        throw new Error(
          `Duplicated badge id "${badge.id}": ${JSON.stringify(duplicated)} ${JSON.stringify(badge)}`,
        );
      }
      return { ...acc, [badge.id]: badge };
    },
    {} as Record<BadgeName, Badge>,
  );
}

export const badges: Record<BadgeName, Badge> = createBadges(
  {
    id: "TEST",
    name: defineMessage({
      id: "test-name",
      defaultMessage: "Quantum Badge",
    }),
    description: defineMessage({
      id: "test-description",
      defaultMessage:
        "You did some awesome work, this really deserves a badge!",
    }),
    image: test,
  },
  {
    id: "PARIS_2024_WINNERS",
    image: paris2024_winners,
    name: defineMessage({
      id: "paris2024-winners-badge",
      defaultMessage: "Big Quantum Hackathon Paris 2024 Winner",
    }),
    description: defineMessage({
      id: "paris2024-winners-badge-description",
      defaultMessage:
        "Won the Big Quantum Hackathon Sports Edition, held in Paris from May 25 to 28, 2024.",
    }),
  },
  {
    id: "PARIS_2024_HACKERS",
    image: paris2024_hackers,
    name: defineMessage({
      id: "paris2024-hackers-badge",
      defaultMessage: "Big Quantum Hackathon Paris 2024 Participant",
    }),
    description: defineMessage({
      id: "paris2024-hackers-badge-description",
      defaultMessage:
        "Participated in the Big Quantum Hackathon Sports Edition, held in Paris from May 25 to 28, 2024.",
    }),
  },
  {
    id: "CHICAGO_2023",
    image: chicago_2023,
    name: defineMessage({
      id: "chicago2023-badge",
      defaultMessage: "BIG Quantum Hackathon Chicago 2023 Participant",
    }),
    description: defineMessage({
      id: "chicago2023-badge-description",
      defaultMessage:
        "Participated in the BIG Quantum Hackathon by the Chicago Quantum Exchange & QuantX, held in Chicago (Sept, 2023).",
    }),
  },
  {
    id: "TRIESTE_2023",
    image: trieste_2023,
    name: defineMessage({
      id: "trieste2023-badge",
      defaultMessage: "ICTP - Quantinuum Quantum Hackathon 2023 Participant",
    }),
    description: defineMessage({
      id: "trieste2023-badge-description",
      defaultMessage:
        "Participated in the ICTP - Quantinuum Quantum Hackathon, held in Trieste (April, 2023).",
    }),
  },
  {
    id: "PARIS_2023",
    image: paris_2023,
    name: defineMessage({
      id: "paris2023-badge",
      defaultMessage: "BIG QC-AI-HPC Hackathon 2023 Participant",
    }),
    description: defineMessage({
      id: "paris2023-badge-description",
      defaultMessage:
        "Participated in the BIG QC-AI-HPC Hackathon by QuantX, held in Paris (March, 2023).",
    }),
  },
  {
    id: "GRENOBLE_2022",
    image: grenoble_2022,
    name: defineMessage({
      id: "grenoble2022-badge",
      defaultMessage: "Quantum Hackathon 2022 Participant",
    }),
    description: defineMessage({
      id: "grenoble2022-badge-description",
      defaultMessage:
        "Participated in the Quantum Hackathon by QuantX, held in Grenoble (October, 2022).",
    }),
  },
  {
    id: "MONTREAL_2022",
    image: montreal_2022,
    name: defineMessage({
      id: "montreal2022-badge",
      defaultMessage: "Quantum Hackathon 2022 Participant",
    }),
    description: defineMessage({
      id: "montreal2022-badge-description",
      defaultMessage:
        "Participated in the Quantum Hackathon by Québec Quantique & QuantX, held in Montreal (June, 2022).",
    }),
  },
  {
    id: "BIG_PARIS_2021",
    image: bigparis_2021,
    name: defineMessage({
      id: "bigparis2021-badge",
      defaultMessage: "BIG Quantum Hackathon 2021 Participant",
    }),
    description: defineMessage({
      id: "bigparis2021-badge-description",
      defaultMessage:
        "Participated in the BIG Quantum Hackathon by QuantX, held in Paris (October, 2021).",
    }),
  },
  {
    id: "PARIS_2021",
    image: paris_2021,
    name: defineMessage({
      id: "paris2021-badge",
      defaultMessage: "Quantum Hackathon 2021 Participant",
    }),
    description: defineMessage({
      id: "paris2021-badge-description",
      defaultMessage:
        "Participated in the Quantum Hackathon by QuantX, held in Paris (March, 2021).",
    }),
  },
  {
    id: "QUANTUM_PIONEER",
    image: quantum_pioneer,
    name: defineMessage({
      id: "quantum-pioneer-badge",
      defaultMessage: "Quantum Pioneer",
    }),
    description: defineMessage({
      id: "quantum-pioneer-badge-description",
      defaultMessage:
        "Congratulations on submitting your first entry to Aqora! You've taken the first step in your quantum journey. Many more challenges and achievements await as you continue to explore new frontiers.",
    }),
  },
  {
    id: "INGENII_2024_FIRST",
    image: ingenii2024first,
    name: defineMessage({
      defaultMessage:
        "Clinical Trial Optimization Competition 2024 by Ingenii First Prize",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on winning First Prize in the Clinical Trial Optimization Competition 2024 by Ingenii. Your work not only secured the top spot but also surpassed Ingenii’s internal benchmark.",
    }),
  },
  {
    id: "INGENII_2024_SECOND",
    image: ingenii2024second,
    name: defineMessage({
      defaultMessage:
        "Clinical Trial Optimization Competition 2024 by Ingenii Second Prize",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on winning Second Prize in the Clinical Trial Optimization Competition 2024 by Ingenii. Your achievement has set a new standard by exceeding Ingenii’s internal benchmark.",
    }),
  },
  {
    id: "INGENII_2024_THIRD",
    image: ingenii2024third,
    name: defineMessage({
      defaultMessage:
        "Clinical Trial Optimization Competition 2024 by Ingenii Third Prize",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on winning Third Prize in the Clinical Trial Optimization Competition 2024 by Ingenii. Your involvement has contributed to the success of this outstanding competition.",
    }),
  },
  {
    id: "INGENII_2024_OTHERS",
    image: ingenii2024default,
    name: defineMessage({
      defaultMessage:
        "Clinical Trial Optimization Competition 2024 by Ingenii Participant",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on participating in the Clinical Trial Optimization Competition 2024 by Ingenii. Your involvement has contributed to the success of this outstanding competition.",
    }),
  },
  {
    id: "INGENII_2024_SPECIAL",
    image: ingenii2024special,
    name: defineMessage({
      defaultMessage:
        "Clinical Trial Optimization Competition 2024 by Ingenii Special Prize",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on winning the Special Prize in the Clinical Trial Optimization Competition 2024 by Ingenii. Your involvement has contributed to the success of this outstanding competition.",
    }),
  },
  {
    id: "Q2B2024_GOLD",
    image: q2b2024gold,
    name: defineMessage({
      defaultMessage: "Hackathon Champion - Q2B Silicon Valley 2024",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to the top team of the IBM Hackathon at Q2B Silicon Valley 2024! Your solution stood out for its technical brilliance, creativity, and real-world impact, earning you the ultimate recognition as this year's champions. A testament to your quantum innovation and collaborative excellence.",
    }),
  },
  {
    id: "Q2B2024_SILVER",
    image: q2b2024silver,
    name: defineMessage({
      defaultMessage:
        "Hackathon Innovator - 2nd Place Team - Q2B Silicon Valley 2024",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing the second-place team of the IBM Hackathon at Q2B Silicon Valley 2024, this badge celebrates your exceptional creativity and technical skill. Your solution impressed the judges, demonstrating your ability to solve complex problems and advance quantum computing's frontiers.",
    }),
  },
  {
    id: "Q2B2024_BRONZE",
    image: q2b2024bronze,
    name: defineMessage({
      defaultMessage:
        "Hackathon Trailblazer - 3rd Place Team - Q2B Silicon Valley 2024",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to the third-place team of the IBM Hackathon at Q2B Silicon Valley 2024! Your innovative approach and technical expertise earned you this distinction, highlighting your role as pioneers in tackling real-world challenges with quantum solutions.",
    }),
  },
  {
    id: "Q2B2024_ONSITE",
    image: q2b2024onsite,
    name: defineMessage({
      defaultMessage: "On-Site Participant - Q2B Hackathon 2024",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to those who participated in the IBM Hackathon at Q2B Silicon Valley 2024 in person. Your presence brought energy and engagement to the event, helping to build a collaborative and hands-on quantum community.",
    }),
  },
  {
    id: "Q2B2024_REMOTE",
    image: q2b2024remote,
    name: defineMessage({
      defaultMessage: "Global Participant - Q2B Hackathon 2024",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to remote participants of the IBM Hackathon at Q2B Silicon Valley 2024. Your contributions highlight the global reach and collaborative spirit of the quantum community, proving that innovation knows no boundaries. Together, we shape the future of quantum technology.",
    }),
  },
  {
    id: "NOVACENE_2024",
    image: novacene2024,
    name: defineMessage({
      defaultMessage: "Malicious Login Detection 2024 by NovaceneAI – Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Congratulations on winning the Malicious Login Detection 2024 Competition by NovaceneAI! Your innovative use of quantum computing demonstrated impressive potential for enhancing the detection of suspicious logins, marking a meaningful contribution to the evolution of cybersecurity solutions.",
    }),
  },
  {
    id: "QINNOVISION_2025_WINNER",
    image: qinnovision2025winner,
    name: defineMessage({
      defaultMessage: "QInnovision Challenge 2024-2025 Winner!",
    }),
    description: defineMessage({
      defaultMessage:
        "Your groundbreaking solution demonstrated exceptional technical ingenuity, creativity, and tangible impact, securing your place as this year’s champions. This badge is a testament to your pioneering quantum innovation and outstanding teamwork.",
    }),
  },
  {
    id: "QINNOVISION_2025_FINALIST",
    image: qinnovision2025finalist,
    name: defineMessage({
      defaultMessage: "QInnovision Challenge 2024-2025 Finalist!",
    }),
    description: defineMessage({
      defaultMessage:
        "Your team’s outstanding solution distinguished itself among fierce competition, demonstrating exceptional creativity, technical expertise, and a forward-thinking approach. This badge recognizes your achievement in reaching the final stage, a testament to your dedication and impact in the quantum ecosystem.",
    }),
  },
  {
    id: "QUANTUM_SIGNALS_LOB_2025_FIRST",
    image: quantumsignalslob2025first,
    name: defineMessage({
      defaultMessage: "🏆 Quantum Trading Oracle  – 1st Place 🏆",
    }),
    description: defineMessage({
      defaultMessage:
        "You've cracked the code of the financial markets, at least as far as quantum neural networks can take us (for now)! Your solution outperformed the competition, proving that quantum-powered stock trend prediction is more than just theory. Wear this badge with pride. Wall Street might be calling soon!",
    }),
  },
  {
    id: "QUANTUM_SIGNALS_LOB_2025_SECOND",
    image: quantumsignalslob2025second,
    name: defineMessage({
      defaultMessage: "Schrödinger’s Trader – 2nd Place - Second Prize",
    }),
    description: defineMessage({
      defaultMessage:
        "Halfway to quantum market domination! Your model navigated the chaotic world of Limit Order Book data with finesse, showing impressive predictive power. Just a tiny quantum fluctuation away from victory, but still a monumental achievement, this badge proves you're ahead of the curve in quantum finance!",
    }),
  },
  {
    id: "QML_SUMMER_SCHOOL_2025",
    image: qmlsummerschool2025,
    name: defineMessage({
      defaultMessage: "QML Summer School 2025 by Haiku",
    }),
    description: defineMessage({
      defaultMessage:
        "Participated in the QML Summer School 2025 Hackathon on Aqora, turning QML theory into practice.",
    }),
  },
  {
    id: "EPRI2025_FIRST",
    image: epri_1st,
    name: defineMessage({
      defaultMessage: "EPRI 2025: 1st Place → Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to Ridwan Sakidja (Missouri State University) for a quantum-enhanced framework modeling fusion material degradation with near-term feasibility. Ridwan Sakidja's work will appear with the other winners in an EPRI white paper.",
    }),
  },
  {
    id: "EPRI2025_SECOND",
    image: epri_2nd,
    name: defineMessage({
      defaultMessage: "EPRI 2025: 2nd Place → Runner‑Up",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to Justus Lau (Heidelberg University) for a hybrid quantum-classical approach to model neutron damage in fusion materials. Justus Lau's work will appear with the other winners in an EPRI white paper.",
    }),
  },
  {
    id: "EPRI2025_THIRD",
    image: epri_3rd,
    name: defineMessage({
      defaultMessage: "EPRI 2025: 3rd Place → Finalist",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to Kory Burns (University of Virginia) for using quantum sensors to monitor and control fusion plasma. Kory Burns' work will appear with the other winners in an EPRI white paper.",
    }),
  },
  {
    id: "GIC2025_JPMC",
    image: gic2025jpmc,
    name: defineMessage({
      defaultMessage: "Financial Feedback Systems",
    }),
    description: defineMessage({
      defaultMessage:
        "Honoring breakthrough quantum circuits from the Connected DMV G.I.C. that emulate real-time financial decision-making, paving the way for smarter, adaptive risk strategies.",
    }),
  },
  {
    id: "GIC2025_WELLS_FARGO",
    image: gic2025wellsfargo,
    name: defineMessage({
      defaultMessage: "QAOA Optimisation (QOKit)",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for advancing the performance of QAOA on QOKit during the Connected DMV G.I.C., unlocking faster, more scalable optimization solutions across finance, logistics, and beyond.",
    }),
  },
  {
    id: "GIC2025_WORLD_BANK",
    image: gic2025worldbank,
    name: defineMessage({
      defaultMessage: "Climate Risk Insurance",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing innovative quantum models developed during the Connected DMV G.I.C., reshaping climate risk insurance to make protection more accurate, fair, and accessible for vulnerable communities.",
    }),
  },
  {
    id: "GIC2025_MITRE",
    image: gic2025mitre,
    name: defineMessage({
      defaultMessage: "Quantum Asphalt Simulation",
    }),
    description: defineMessage({
      defaultMessage:
        "Celebrating quantum simulations presented at the Connected DMV G.I.C. that reveal new insights into asphalt durability, extending road lifetimes and reducing global maintenance costs.",
    }),
  },
  {
    id: "GIC2025_NEURO_QUANTUM",
    image: gic2025neuroquantum,
    name: defineMessage({
      defaultMessage: "Quantum Neuroscience",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing pioneering work from the Connected DMV G.I.C. that applies quantum models to uncover hidden brain patterns, bringing us closer to new neurotechnologies and treatments.",
    }),
  },
  {
    id: "BRADFORD_CLINICAL_TRIAL_OPTIMIZATION",
    image: bradfordclinicaltrialoptimization,
    name: defineMessage({
      defaultMessage: "Clinical Trial Optimization (Ingenii)",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for optimizing clinical trials through quantum or hybrid models, improving patient stratification and accelerating medical innovation.",
    }),
  },
  {
    id: "BRADFORD_BRING_YOUR_OWN_USE_CASE",
    image: bradfordbringyourownusecase,
    name: defineMessage({
      defaultMessage: "Bring Your Own Use Case (Quantinuum)",
    }),
    description: defineMessage({
      defaultMessage:
        "Honoring bold, original ideas where quantum computing adds measurable value to real-world problems, advancing the International Year of Quantum goals.",
    }),
  },
  {
    id: "BRADFORD_QUANTUM_BRUSH",
    image: bradfordquantumbrush,
    name: defineMessage({
      defaultMessage: "Quantum Brush",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for developing a creative quantum “brush” that fuses art and computation, showcasing how quantum algorithms can power new forms of digital expression.",
    }),
  },
  {
    id: "BRADFORD_PROJECT_ELEVEN_POST_QUANTUM_CRYPTOGRAPHY",
    image: bradfordcryptography,
    name: defineMessage({
      defaultMessage: "Project Eleven – Post-Quantum Cryptography",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing innovative solutions in post-quantum cryptography, demonstrating algorithmic insight and practical relevance for future-proof security.",
    }),
  },
  {
    id: "PUSHQUANTUM_HAIQU_EARLY_FAULT_TOLERANT_CIRCUITS",
    image: pushquantumhaiqearlyfaulttolerantcircuits,
    name: defineMessage({
      defaultMessage: "Haiqu – Early Fault-Tolerant Circuits",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for developing a dynamic fault-tolerance strategy that smartly protects qubits over time, improving circuit fidelity under realistic noise constraints.",
    }),
  },
  {
    id: "PUSHQUANTUM_QORO_QUANTUM_MOLECULAR_DETECTIVE",
    image: pushquantumqoroquantummoleculardetective,
    name: defineMessage({
      defaultMessage: "Qoro Quantum – Molecular Detective",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing quantum chemistry solutions using VQE and custom ansätze to uncover molecular structures with optimized accuracy and computational efficiency.",
    }),
  },
  {
    id: "PUSHQUANTUM_QUANDELA_QUANTUM_OPTION_PRICING",
    image: pushquantumquandelaquantumoptionpricing,
    name: defineMessage({
      defaultMessage: "Quandela – Quantum Option Pricing",
    }),
    description: defineMessage({
      defaultMessage:
        "Honoring quantum machine learning models that predict financial option prices, showcasing the potential of photonic computing in real-world forecasting.",
    }),
  },
  {
    id: "QFF_COLOR_CODE",
    image: qffcolorcode,
    name: defineMessage({
      defaultMessage: "Qiskit Fall Fest Winner – Color Code (Entropica Labs)",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for a winning implementation of a color code in Loom, demonstrating correct stabilizer construction, syndrome extraction circuits, logical operations, and successful interpretation for execution.",
    }),
  },
  {
    id: "QFF_QUANTUM_RANDOM_WALK",
    image: qffquantumrandomwalk,
    name: defineMessage({
      defaultMessage:
        "Qiskit Fall Fest Winner – Quantum Random Walk Option Pricing",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for a winning implementation of option pricing using quantum random walks, accurately approximating Black–Scholes prices with quantum circuits and strong alignment with classical benchmarks.",
    }),
  },
  {
    id: "QFF_QUANTUM_MACHINE_LEARNING",
    image: qffquantummachinelearning,
    name: defineMessage({
      defaultMessage:
        "Qiskit Fall Fest Winner – Quantum Machine Learning Option Pricing",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for a winning quantum machine learning approach to option pricing, using hybrid quantum-classical models to learn price distributions from data and achieve strong predictive performance.",
    }),
  },
  {
    id: "BQH_QATAR_WINNER_2025",
    image: bqhqatarwinner2025,
    name: defineMessage({
      defaultMessage: "Big Quantum Hackathon Qatar 2025 – Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for delivering a high-impact quantum or hybrid solution at the Big Quantum Hackathon Qatar 2025, combining technical excellence with clear business relevance aligned with Qatar’s digital transformation priorities.",
    }),
  },
  {
    id: "BQH_QATAR_FINALIST_2025",
    image: bqhqatarfinalist2025,
    name: defineMessage({
      defaultMessage: "Big Quantum Hackathon Qatar 2025 – Finalist",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing finalist teams of the Big Quantum Hackathon Qatar 2025 for developing strong, purpose-driven quantum solutions with solid technical foundations and credible pathways to real-world adoption.",
    }),
  },
  {
    id: "HTH_WINNER_TEAM",
    image: hthwinnerteam,
    name: defineMessage({
      defaultMessage: "Hack The Horizon – Winner Team",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to the top team of Hack The Horizon for delivering an exceptional quantum solution combining technical depth, innovation, and strong relevance to Africa’s real-world challenges.",
    }),
  },
  {
    id: "HTH_MOST_INNOVATIVE_IDEA",
    image: hthmostinnovativeidea,
    name: defineMessage({
      defaultMessage: "Hack The Horizon – Most Innovative Idea",
    }),
    description: defineMessage({
      defaultMessage:
        "Recognizing the team that proposed the most original and forward-thinking quantum idea, pushing boundaries in approach, creativity, and use of quantum or quantum-inspired methods.",
    }),
  },
  {
    id: "HTH_MOST_IMPACTFUL_TEAM",
    image: hthmostimpactfulteam,
    name: defineMessage({
      defaultMessage: "Hack The Horizon – Most Impactful Team",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for a solution with the highest potential for real-world impact in the African context, demonstrating clear value, scalability, and relevance to societal or economic needs.",
    }),
  },
  {
    id: "HTH_PARTICIPATION",
    image: hthparticipation,
    name: defineMessage({
      defaultMessage: "Hack The Horizon – Participation Badge",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded to participants of Hack The Horizon for contributing to Africa’s growing quantum ecosystem through collaboration, learning, and hands-on innovation.",
    }),
  },
  {
    id: "QVOLUTION_26_ENERGY",
    image: QVOLUTION_26_ENERGY,
    name: defineMessage({
      defaultMessage: "Energy Grid Optimization – Track Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for engineering a quantum optimization strategy to compute the Maximum Power Energy Section of a real-world power grid, pushing QAOA beyond the limits of current hardware on Rigetti’s platform.",
    }),
  },
  {
    id: "QVOLUTION_26_LINEAR_DIFF",
    image: QVOLUTION_26_LINEAR_DIFF,
    name: defineMessage({
      defaultMessage: "Solving Linear Differential Equations – Track Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for implementing a quantum algorithm to solve the harmonic oscillator equation, bridging the gap between quantum algorithm theory and working circuit-level execution.",
    }),
  },
  {
    id: "QVOLUTION_26_QUANTUM_FOR_GOOD",
    image: QVOLUTION_26_QUANTUM_FOR_GOOD,
    name: defineMessage({
      defaultMessage: "Quantum for Good – Track Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for designing a conceptual quantum solution addressing a real-world social or environmental crisis, demonstrating the human potential of quantum technologies.",
    }),
  },
  {
    id: "QVOLUTION_26_FINANCE",
    image: QVOLUTION_26_FINANCE,
    name: defineMessage({
      defaultMessage: "Option Pricing in Finance – Track Winner",
    }),
    description: defineMessage({
      defaultMessage:
        "Awarded for building a Quantum Machine Learning model to predict option prices using quantum reservoir computing on Quandela’s photonic platform.",
    }),
  },
  {
    id: "GIC26_MITSUBISHI",
    image: gic2026mitsubishi,
    name: defineMessage({
      defaultMessage:
        "Mitsubishi Chemical & The National Institute of Advanced Industrial Science and Technology (AIST)",
    }),
    description: defineMessage({
      defaultMessage:
        "Winner of the Advanced Materials track of the 2026 Global Industry Challenge! You combined AI and quantum simulation to push the frontier of semiconductor and chemical materials discovery, and impressed Mitsubishi Chemical and AIST along the way. The materials of tomorrow just got a little closer thanks to you!",
    }),
  },
  {
    id: "GIC26_QBRAID_MITRE_JONES",
    image: gic2026qbraidmitrejones,
    name: defineMessage({
      defaultMessage: "qBraid, MITRE & JonesTrading",
    }),
    description: defineMessage({
      defaultMessage:
        "Winner of the Dynamic Systems Forecasting track of the 2026 Global Industry Challenge! You harnessed quantum reservoir computing to read the future in time-series data, from financial markets to climate patterns, and won over qBraid, MITRE and JonesTrading. Turns out the forecast was right: you were destined to win!",
    }),
  },
  {
    id: "GIC26_QUANTUM_COMPUTING_INC",
    image: gic2026quantumcomputinginc,
    name: defineMessage({
      defaultMessage: "Quantum Computing Inc.",
    }),
    description: defineMessage({
      defaultMessage:
        "Winner of the Quantum Computing Inc. Energy Infrastructure track of the 2026 Global Industry Challenge! You optimized distributed microgrid networks for cost efficiency and resilience, proving that quantum computing can help keep the lights on. Your solution truly powered up the competition!",
    }),
  },
  {
    id: "GIC26USDOE",
    image: gic2026usdoe,
    name: defineMessage({
      defaultMessage:
        "U.S. Department of Energy Office of Technology Commercialization",
    }),
    description: defineMessage({
      defaultMessage:
        "Winner of the U.S. Department of Energy Energy Infrastructure track of the 2026 Global Industry Challenge! You tackled a real-world grid planning problem, using quantum and hybrid computing to decide where energy storage and microgrids should go, and earned the recognition of DOE experts. Your work sets a benchmark for the future of a stronger, smarter grid!",
    }),
  },
);
